import { useLoader } from "@react-three/fiber";
import { Bloom, EffectComposer } from "@react-three/postprocessing";
import { forwardRef, MutableRefObject, Suspense } from "react";
import * as THREE from "three";

export interface VehicleProps {
  wakeRef: MutableRefObject<THREE.MeshPhongMaterial>;
  glowRef: MutableRefObject<any>;
}

export const Vehicle = forwardRef<THREE.Mesh, VehicleProps>(({ glowRef, wakeRef }, ref) => {
  const geometry = useLoader(THREE.BufferGeometryLoader, "./models/vehicle/geometry.json");
  const wakeGeom = useLoader(THREE.BufferGeometryLoader, "./models/vehicle/wake.json");

  const texture = useLoader(THREE.TextureLoader, "./images/ship.png");
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.minFilter = THREE.NearestFilter;
  texture.magFilter = THREE.NearestFilter;

  const glow = useLoader(THREE.TextureLoader, "./images/glow.png");
  glow.colorSpace = THREE.SRGBColorSpace;
  glow.minFilter = THREE.NearestFilter;
  glow.magFilter = THREE.NearestFilter;

  const wake = useLoader(THREE.TextureLoader, "./images/wake.png");
  wake.colorSpace = THREE.SRGBColorSpace;
  wake.minFilter = THREE.NearestFilter;
  wake.magFilter = THREE.NearestFilter;

  return (
    <mesh position={[0, 0.43, 0]} ref={ref}>
      <mesh geometry={geometry} scale={0.03}>
        <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
      </mesh>
      <sprite position={[0, 0.02, 0.29]} scale={0.4}>
        <spriteMaterial ref={glowRef} map={glow} depthTest={false} blending={THREE.AdditiveBlending} transparent />
      </sprite>
      <mesh geometry={wakeGeom} scale={[0.03, 0.03, 0.015]}>
        <Suspense fallback={null}>
          <EffectComposer>
            <Bloom opacity={1} />
          </EffectComposer>
        </Suspense>
        <meshPhongMaterial
          emissiveIntensity={1}
          emissive={0x99ffff}
          map={wake}
          opacity={0.25}
          blending={THREE.AdditiveBlending}
          side={THREE.BackSide}
          transparent
          ref={wakeRef}
        />
      </mesh>
    </mesh>
  );
});
